enum BlobContainers {
  Documents = "documents",
}

export default BlobContainers;
